import React from 'react';

export default function PageHero({ kicker, title, desc, modifier }) {
  return (
    <section className={`page-hero${modifier ? ` page-hero--${modifier}` : ''}`}>
      <div className="container page-hero-inner">
        <div>
          <div className="page-hero-kicker">{kicker}</div>
          <h1>{title}</h1>
          <p>{desc}</p>
        </div>
      </div>
    </section>
  );
}
